import { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap-v5';
import { useHistory, useLocation } from 'react-router-dom';
import Select from 'react-select';
import axios from 'axios';
import { useFormik } from 'formik';
import { KTSVG } from 'src/_metronic/helpers';
import { withPimURL } from 'src/helpers/service';
import validator from 'validator';
import { object, string } from 'yup';
import * as yup from 'yup';

const PLATFORM = process.env.REACT_APP_PLATFORM;
const selectOptions = [
  { value: '1', label: '1 Ay' },
  { value: '2', label: '2 Ay' },
  { value: '3', label: '3 Ay' },
  { value: '4', label: '4 Ay' },
  { value: '5', label: '5 Ay' },
  { value: '6', label: '6 Ay' },
];
export function ChangePassword() {
  const history = useHistory();

  const [currentPasswordVisible, setCurrentPasswordVisible] = useState(false);
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);
  const [newAgainPasswordVisible, setNewAgainPasswordVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);
  const [success, setSuccess] = useState<any>(null);
  const params: any = useLocation();
  const initialValues = {
    password: '',
    newPassword: '',
    verifyPassword: '',
    period: '',
  };
  const newPasswordSchema = object().shape({
    password: string().min(6, 'Şifre en az 6 karakterden oluşmalıdır.').required('Bu alan zorunludur.'),
    newPassword: string().min(6, 'Şifre en az 6 karakterden oluşmalıdır.').max(12, 'Şifre en fazla 12 karakterden oluşmalıdır.').required('Bu alan zorunludur.'),
    verifyPassword: string()
      .min(6, 'Şifre en az 6 karakterden oluşmalıdır.')
      .max(12, 'Şifre en fazla 12 karakterden oluşmalıdır.')
      .required('Bu alan zorunludur.')
      .oneOf([yup.ref('newPassword'), null], 'Parolalar eşleşmiyor.'),
    period: yup.number().required('Bu alan zorunludur.'),
  });
  const validate = (value: string): boolean => {
    if (
      validator.isStrongPassword(value, {
        minLength: 6,
        minLowercase: 1,
        minUppercase: 1,
        minNumbers: 1,
        minSymbols: 1,
        returnScore: undefined,
      })
    ) {
      return true;
    } else {
      return false;
    }
  };
  const formik = useFormik({
    initialValues,
    validationSchema: newPasswordSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const VENDOR_AUTH_URL = `${process.env.REACT_APP_API_AUTH_URL}`;
      setLoading(true);
      try {
        if (validate(values.newPassword)) {
          const { headers, ip = '' } = await axios.get(withPimURL('/vendor/my-ip')).then((res) => res.data);
          const clientIp = headers?.['client-ip']?.[0] || ip || '';
          const payload = {
            userMail: params?.state?.email,
            oldPassword: values.password,
            newPassword: values.newPassword,
            passwordRenewalFrequency: Number(values.period),
            platform: PLATFORM,
            clientIp: ip,
          };

          await axios.post(`${VENDOR_AUTH_URL}/change-expired-password`, payload);
          setSuccess('Şifreniz başarıyla güncellendi.');
          setError(null);
          resetForm();
          history.push('/auth');
        } else {
          setError('Şifreniz belirtilen kriterlere uymuyor.');
        }
      } catch (error: any) {
        switch (error.response.data.code) {
          case 403:
            setError(error?.response?.data?.message);
            break;
          default:
            setError('Bir sorun oluştu.');
            break;
        }
        setSubmitting(false);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <form className="form" noValidate onSubmit={formik.handleSubmit}>
        <div className="card-title my-10">
          <h3>Şifre Güncelle</h3>
        </div>
        <div className="row align-items-center mb-10">
          <div className="col-lg-4">Mevcut Şifreniz</div>
          <div className="col-lg-8">
            <div className="position-relative w-100">
              <input
                type={currentPasswordVisible ? 'text' : 'password'}
                placeholder="Mevcut şifrenizi giriniz"
                className={`form-control  w-100 h-100 pe-10 fw-normal ${formik.touched.password && formik.errors.password ? 'border-danger' : null}`}
                {...formik.getFieldProps('password')}
              />{' '}
              {formik.touched.password && formik.errors.password && (
                <OverlayTrigger placement="top" overlay={<Tooltip id="password">{formik.errors.password}</Tooltip>}>
                  <div className="position-absolute translate-middle-y top-50 end-0 me-15 bg-transparent">
                    <KTSVG path="/media/icons/duotone/General/Info.svg" className="svg-icon-2 text-danger svg-icon-gray-500 " />
                  </div>
                </OverlayTrigger>
              )}
              <div onClick={() => setCurrentPasswordVisible(!currentPasswordVisible)} className="position-absolute end-0 bottom-25 px-5 cursor-pointer">
                {!currentPasswordVisible ? (
                  <KTSVG path="/media/icons/duotone/Form/eye-on.svg" className="svg-icon-2" />
                ) : (
                  <KTSVG path="/media/icons/duotone/Form/eye-off.svg" className="svg-icon-2" />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row align-items-center mb-10">
          <div className="col-lg-4">Yeni Şifreniz</div>
          <div className="col-lg-8">
            <div className="position-relative w-100">
              <input
                type={newPasswordVisible ? 'text' : 'password'}
                className={`form-control  w-100 h-100 pe-10 fw-normal ${formik.touched.newPassword && formik.errors.newPassword ? 'border-danger' : null}`}
                {...formik.getFieldProps('newPassword')}
                placeholder="Yeni şifrenizi giriniz"
              />{' '}
              {formik.touched.newPassword && formik.errors.newPassword && (
                <OverlayTrigger placement="top" overlay={<Tooltip id="newPassword">{formik.errors.newPassword}</Tooltip>}>
                  <div className="position-absolute translate-middle-y top-50 end-0 me-15 bg-transparent">
                    <KTSVG path="/media/icons/duotone/General/Info.svg" className="svg-icon-2 text-danger svg-icon-gray-500 " />
                  </div>
                </OverlayTrigger>
              )}
              <div onClick={() => setNewPasswordVisible(!newPasswordVisible)} className="position-absolute end-0 bottom-25 px-5 cursor-pointer">
                {!newPasswordVisible ? (
                  <KTSVG path="/media/icons/duotone/Form/eye-on.svg" className="svg-icon-2" />
                ) : (
                  <KTSVG path="/media/icons/duotone/Form/eye-off.svg" className="svg-icon-2" />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row align-items-center mb-10">
          <div className="col-lg-4">Yeni Şifre Tekrarı</div>
          <div className="col-lg-8">
            <div className="position-relative w-100">
              <input
                type={newAgainPasswordVisible ? 'text' : 'password'}
                placeholder="Yeni şifrenizi tekrar giriniz"
                className={`form-control w-100 h-100 pe-10 fw-normal ${formik.touched.verifyPassword && formik.errors.verifyPassword ? 'border-danger' : null}`}
                {...formik.getFieldProps('verifyPassword')}
              />{' '}
              {formik.touched.verifyPassword && formik.errors.verifyPassword && (
                <OverlayTrigger placement="top" overlay={<Tooltip id="verifyPassword">{formik.errors.verifyPassword}</Tooltip>}>
                  <div className="position-absolute translate-middle-y top-50 end-0 me-15 bg-transparent">
                    <KTSVG path="/media/icons/duotone/General/Info.svg" className="svg-icon-2 text-danger svg-icon-gray-500 " />
                  </div>
                </OverlayTrigger>
              )}
              <div onClick={() => setNewAgainPasswordVisible(!newAgainPasswordVisible)} className="position-absolute end-0 bottom-25 px-5 cursor-pointer">
                {!newAgainPasswordVisible ? (
                  <KTSVG path="/media/icons/duotone/Form/eye-on.svg" className="svg-icon-2" />
                ) : (
                  <KTSVG path="/media/icons/duotone/Form/eye-off.svg" className="svg-icon-2" />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row align-items-center mb-10">
          <div className="col-lg-4">Periyot</div>
          <div className="col-lg-8">
            <Select
              className={` w-100 h-100  fw-normal ${formik.touched.period && formik.errors.period ? 'border-danger' : null}`}
              placeholder="Şifre periyodunu seçin"
              options={selectOptions}
              onChange={(e: any) => formik.setFieldValue('period', e.value)}
            />
          </div>
        </div>
        <div className="row align-items-center mb-10 border pt-4 rounded">
          <div className="col-lg-12">
            <label className="fw-bold fs-6">Şifreniz aşağıda yer alan kriterlere uymalıdır;</label>
          </div>
          <div className="col-lg-12 mt-5 r">
            <ul>
              <li>Şifre en az 6 karakterden oluşmalıdır.</li>
              <li>Şifre en fazla 12 karakterden oluşmalıdır.</li>
              <li>Şifre en az bir rakam içermelidir.</li>
              <li>Şifre en az bir büyük, bir küçük harf içermelidir.</li>
              <li>Şifre en az bir özel karakter içermelidir.</li>
            </ul>
          </div>
        </div>
        <button type="submit" className="btn btn-light-success mb-4" disabled={formik.isSubmitting || !formik.isValid || loading}>
          <span className="indicator-label me-3">Güncelle</span>
          {loading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : null}
        </button>

        {error && (
          <div className="row">
            <div className="alert alert-danger">{error}</div>
          </div>
        )}
      </form>
    </>
  );
}
